module.exports = __webpack_public_path__ + "static/media/AB_A6_4.a4979bf6.jpg";